import type { WSModel } from "@/services/socket/ws.service";
import { WSCommands } from "@/constants/ws";
import { socketEmitter } from "@/services/socket/socket-emitter";

export class ChatHandler implements WSModel {
  handleWSData(data: any) {
    if (!data.command) {
      return;
    }

    if (data.command === WSCommands.messages) {
      if (data.messages) {
        socketEmitter.emit("chat:messages", { messages: data.messages });
      }
    } else if (data.command === WSCommands.message) {
      const message = { ...data };
      delete message.command;
      socketEmitter.emit("chat:message", { message });
    } else if (data.command === WSCommands.threads) {
      if (data.threads) {
        socketEmitter.emit("chat:threads", { threads: data.threads });
      }
    } else if (data.command === WSCommands.thread) {
      const thread = { ...data };
      delete thread.command;
      socketEmitter.emit("chat:thread", { thread });
    }
  }

  onlineStatusHandler(isOnline: boolean): void {
    socketEmitter.emit("chat:online-status", { isOnline });
  }
}
